<template>
  <div class="sub-asset-item is-flex align-center justify-between" :class="{'is-staged' : isStaged}">
    <div class="is-flex align-center justify-between">
      <icon icon="user" class="is-size-6 grab-cursor"/>
      <div class="is-flex align-center">
        <p class="has-tooltip sub-asset-item-text"
           :class="{'assigned' : !isAvailableItems}"
           :data-tooltip="`${Naming.Technician}: ${technician.full_name}`">
          {{ technician.full_name }}
        </p>
        <p v-if="!isAvailableItems"
           class="has-tooltip sub-asset-item-text assigned is-capitalized"
           :data-tooltip="`${Naming.Technician}: ${technician.email}`">
          <icon class="is-inline is-size-7" icon="address-book"/>
          {{ technician.email }}
          <span v-if="isStaged === true" class="new-tag"
          >Not Saved</span>
        </p>
      </div>
    </div>
    <icon @click="removeFromSelected" v-if="canBeRemoved" class="is-size-5 pl-1 pr-1 hover-highlight-danger"
          icon="times-circle"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'assigned-technician-item',

  props: {
    technician: {
      type: Object,
    },
    isAvailableItems: {
      type: Boolean,
      default: false
    },
    staged: {
      type: Array
    }
  },

  methods: {
    pushToSelected() {
      this.$emit('pushToSelected', this.technician)
    },
    removeFromSelected() {
      this.$emit('removeFromSelected', this.technician)
    },
  },

  computed: {
    ...mapGetters("userPersonas", ["persona"]),
    isStaged(){
      return this.staged?.includes(this.technician)
    },
    canBeRemoved() {
      let technician = this.persona?.technician?.find(assignedTechnician => assignedTechnician.user_id === this.user.id)
      if(technician) {
        return technician.open_job_count === 0
      }

      return true
    },
  }
}
</script>